export default {
	baseUrl: 'http://localhost:8080/springboot39772449/',
	name: '/springboot39772449',
	indexNav: [
		{
			name: '寄养点',
			url: '/index/jiyangdian',
		},
		{
			name: '寄养服务',
			url: '/index/jiyangfuwu',
		},
		{
			name: '宠物养护',
			url: '/index/chongwuyanghu',
		},
		{
			name: '宠物问答',
			url: '/index/chongwuwenda',
		},
		{
			name: '积分商品',
			url: '/index/jifenshangpin',
		},
	],
	cateList: [
	]
}
